function More() {
  return (
    <div className="text-center">
      <a
        href="https://soundcloud.com/raversound"
        target="_blank"
        rel="noopener noreferrer"
        className="hover:text-white Button p-4 rounded-lg"
      >
        Ver más
      </a>
    </div>
  );
}

export default More;
